import './styles.css'

import MenuW from '../../images/menu-w.png'
import MenuB from '../../images/menu-b.png'

export const Menu = () =>{

    const handleMenu = () => {
        const navbar = document.querySelector('#navBar')
        const menu = document.querySelector('.menu')
        if (navbar.classList.contains('hide')){
          menu.setAttribute('src', MenuW)
          navbar.classList.remove('hide')
        }else{
          menu.setAttribute('src', MenuB)
          navbar.classList.add('hide')
          }
      }

    return(
        <div>
            <img src={MenuB} alt="menu" onClick={handleMenu} className="menu" />
        </div>
    )
}



